import { render, staticRenderFns } from "./AddDeclaration.vue?vue&type=template&id=27905dd0&"
import script from "./AddDeclaration.vue?vue&type=script&lang=js&"
export * from "./AddDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports